var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{staticClass:"time-selector",attrs:{"disabled":_vm.disabled,"disabled-times-fct":_vm.disabledTimesFct,"options":_vm.timeslots},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }